import { useEffect, useState } from 'react';
import css from './StaffCompetence.module.css';

import * as staffServices from '../../../../../services/staffServices.js';
import toShort from '../../../../../services/utils/dateParser.js';
import PlusButton from '../../../_common/elements/PlusButton.js';
import ModalForm from '../../../_common/ModalForm.js';

function StaffCompetence({ id }) {
    const template = [
        {
            staffCompetenceId: 2,
            staffCompetenceTitle: 'MTOE',
            initialDate: '2024-01-01',
            refreshDate: '2024-01-01',
            expiryDate: '2024-01-01',
            hasCompetence: 0,
        },
    ];

    const [competenceList, setCompetenceList] = useState([]);
    const [unlockedIndex, setUnlockedIndex] = useState(-1);
    const [oldData, setOldData] = useState({});
    const [nextExp, setNextExp] = useState('');

    useEffect(() => {
        staffServices
            .getOption('competence', id)
            .then((res) => {
                setCompetenceList(res.data);
            })
            .catch((err) => {});
    }, [id]);

    useEffect(() => {
        if (competenceList.length) {
            let sortArr = [...competenceList];
            let sorted = sortArr.sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate));

            setNextExp(
                `${toShort(sorted[0].expiryDate)} (${sorted[0].staffCompetenceTitle}). Days remaining: ${Math.floor(
                    (new Date(sorted[0].expiryDate) - new Date()) / (1000 * 60 * 60 * 24) + 1
                )}`
            );
        }
    }, [competenceList]);

    const editHandle = (index) => {
        if (unlockedIndex === -1) {
            setUnlockedIndex(index);

            // let index = competenceList.indexOf(competenceList.filter((a) => a.staffCompetenceId === staffCompetenceId)[0]);

            setOldData((st) => {
                let arr = competenceList.slice();
                let data = { ...arr[index] };

                return data;
            });
        }
    };

    const cancelhandle = (index) => {
        // let index = competenceList.indexOf(competenceList.filter((a) => a.staffCompetenceId === staffCompetenceId)[0]);

        setCompetenceList((st) => {
            st.splice(index, 1, oldData);

            return st;
        });
        setUnlockedIndex(-1);
    };

    const handleChange = (e, index) => {
        setCompetenceList((state) => {
            let res = state.slice();

            // let index = state.indexOf(state.filter((a) => a.staffCompetenceId === staffCompetenceId)[0]);

            res[index][e.target.id] = e.target.value;

            return res;
        });
    };

    const saveHandle = (e, index) => {
        //add service
        // staffServices.edit(competenceList[index])

        setUnlockedIndex(-1);
    };

    const addCompetence = () => {
        console.log('Add competence');
    };

    return (
        <div className={css.course}>
            <div className={css.header}>
                <h2 className={css.h2}>Competence</h2>
                <span>Next Exp: {nextExp}</span>
                <PlusButton onClick={addCompetence} />
            </div>

            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th className={css.th}>Competence</th>
                        <th className={css.th}>Initial Date</th>
                        <th className={css.th}>Refresh Date</th>
                        <th className={css.th}>Expiry Date</th>
                        <th className={css.th}>Has competence?</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {competenceList?.map((x, index) =>
                        competenceList[0].staffCompetenceId ? (
                            <tr key={x.staffCompetenceId} id={x.staffCompetenceId}>
                                {unlockedIndex === index ? (
                                    <>
                                        <td>{x.staffCompetenceTitle}</td>
                                        <td className={css.editInputs}>
                                            <input
                                                type="date"
                                                id="initialDate"
                                                value={toShort(x.initialDate, 1)}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                        </td>
                                        <td className={css.editInputs}>
                                            <input
                                                type="date"
                                                id="refreshDate"
                                                value={toShort(x.refreshDate, 1)}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                        </td>
                                        <td className={css.editInputs}>
                                            <input
                                                type="date"
                                                id="expiryDate"
                                                value={toShort(x.expiryDate, 1)}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                        </td>
                                        <td className={css.editInputs}>
                                            <input
                                                type="checkbox"
                                                id="hasCompetence"
                                                checked={x.hasCompetence && true}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                        </td>
                                        <td className={css.functionButtons}>
                                            <i className={`${css.green} fa-solid fa-floppy-disk`} onClick={() => saveHandle(index)}></i>
                                            <i className={`${css.red} fa-solid fa-ban`} onClick={() => cancelhandle(index)}></i>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td>{x.staffCompetenceTitle}</td>
                                        <td className={css.center}>{toShort(x.initialDate)}</td>
                                        <td className={css.center}>{toShort(x.refreshDate)}</td>
                                        <td className={css.center}>{toShort(x.expiryDate)}</td>
                                        <td className={css.center}>{x.hasCompetence ? 'Yes' : 'No'}</td>
                                        <td className={css.functionButtons}>
                                            <i className={`${css.blue} fa-solid fa-eye`}></i>
                                            <i className={`${css.orange} fa-solid fa-pen`} onClick={() => editHandle(index)}></i>
                                            <i className={`${css.red} fa-solid fa-trash`}></i>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ) : (
                            <tr>
                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                    No matching records found.
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
            {/* <ModalForm showModal={true}>
                <div>What</div>
            </ModalForm> */}
        </div>
    );
}

export default StaffCompetence;
